"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxesSink = void 0;
const checkbox_group_1 = require("client/components/checkbox-group");
const checkbox_item_1 = require("client/components/checkbox-group/checkbox-item");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const switch_1 = require("client/components/material/switch");
const checkbox_2 = require("client/components/ui/checkbox");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./checkboxes.less");
const checkboxGroupData = [
    { id: 0, label: "live" },
    { id: 1, label: "disabled" },
    { id: 2, label: "archived" }
];
let CheckboxesSink = class CheckboxesSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.checked = true;
        this.checkboxSelections1 = {
            live: false,
            disabled: false,
            archived: false
        };
        this.checkboxSelection2 = {
            live: false,
            disabled: false,
            archived: false
        };
        this.onHandleClickCheckboxItem1 = (item) => {
            this.checkboxSelections1[item.label] = !this.checkboxSelections1[item.label];
        };
        this.onHandleClickCheckboxItem2 = (item) => {
            Object.keys(this.checkboxSelection2).forEach(selection => (this.checkboxSelection2[selection] = false));
            this.checkboxSelection2[item.label] = true;
        };
        this.renderCheckboxItem = (item) => (React.createElement(checkbox_item_1.CheckboxItem, { checked: this.checkboxSelections1[item.label], key: item.id, item: item, onHandleClick: this.onHandleClickCheckboxItem1 }));
        this.renderCheckboxItemRadioMode = (item) => (React.createElement(checkbox_item_1.CheckboxItem, { checked: this.checkboxSelection2[item.label], key: item.id, item: item, onHandleClick: this.onHandleClickCheckboxItem2 }));
    }
    render() {
        return (React.createElement("div", null,
            React.createElement("div", { className: "checkbox" },
                React.createElement("h2", null, "Checkbox"),
                React.createElement(checkbox_2.UiCheckbox, { checked: this.checked, fill: "red", onChange: () => (this.checked = !this.checked) })),
            React.createElement("div", { className: "checkbox-group-demo" },
                React.createElement("h2", null, "Checkbox Group Normal Mode"),
                React.createElement(checkbox_group_1.CheckboxGroup, { data: checkboxGroupData, renderItem: this.renderCheckboxItem.bind(this) })),
            React.createElement("div", { className: "checkbox-group-radio" },
                React.createElement("h2", null, "Checkbox Group Radio Mode"),
                React.createElement(checkbox_group_1.CheckboxGroup, { data: checkboxGroupData, renderItem: this.renderCheckboxItemRadioMode.bind(this) })),
            React.createElement("div", { className: "checkbox" },
                React.createElement("h2", null, "Material Checkbox"),
                React.createElement(checkbox_1.MaterialCheckbox, { label: "Checked" }),
                React.createElement(checkbox_1.MaterialCheckbox, { label: "Indeterminate", indeterminate: true }),
                React.createElement(checkbox_1.MaterialCheckbox, { label: "Disabled", disabled: true })),
            React.createElement("div", { className: "checkbox" },
                React.createElement("h2", null, "Material Swtich"),
                React.createElement(switch_1.MaterialSwitch, { label: "Checked", value: "1" }),
                React.createElement(switch_1.MaterialSwitch, { label: "Disabled", value: "2", disabled: true }))));
    }
};
__decorate([
    mobx_1.observable
], CheckboxesSink.prototype, "checked", void 0);
__decorate([
    mobx_1.observable
], CheckboxesSink.prototype, "checkboxSelections1", void 0);
__decorate([
    mobx_1.observable
], CheckboxesSink.prototype, "checkboxSelection2", void 0);
CheckboxesSink = __decorate([
    mobx_react_1.observer
], CheckboxesSink);
exports.CheckboxesSink = CheckboxesSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/checkboxes/checkboxes.tsx
// module id = 3623
// module chunks = 0